import StromIcon from "./StromIcon";
import GasIcon from "./GasIcon";
import TrinkwasserIcon from "./TrinkwasserIcon";
import AbwasserIcon from "./AbwasserIcon";
import EntsorgungIcon from "./EntsorgungIcon";
import StrassenbeleuchtungIcon from "./StrassenbeleuchtungIcon";
import MobilitaetIcon from "./MobilitaetIcon";
import OepnvIcon from "./OepnvIcon";
import ErneuerbareEnergienIcon from "./ErneuerbareEnergienIcon";
import EnergienaheDienstleistungenIcon from "./EnergienaheDienstleistungenIcon";
import BaederIcon from "./BaederIcon";
import EngagementIcon from "./EngagementIcon";
import QuartiersentwicklungIcon from "./QuartiersentwicklungIcon";
import KlimaUmweltschutzIcon from "./KlimaUmweltschutzIcon";
import KontakteIcon from "./KontakteIcon";
import UeberNewIcon from "./UeberNewIcon";
import NewsIcon from "./NewsIcon";
import StoermeldungenIcon from "./StoermeldungenIcon";
import BauprojekteIcon from "./BauprojekteIcon";
import FoerdermoeglichkeitenIcon from "./FoerdermoeglichkeitenIcon";
import WissenIcon from "./WissenIcon";
import UserIcon from "./UserIcon";
import KommunalrabattIcon from "@/plugins/new-ag-icons-2021/KommunalrabattIcon.vue";
import MagazinIcon from "@/plugins/new-ag-icons-2021/MagazinIcon.vue";
import DashboardRabattprozessIcon from "@/plugins/new-ag-icons-2021/DashboardRabattprozessIcon.vue";
import DashboardHandshakeIcon from "@/plugins/new-ag-icons-2021/DashboardHandshakeIcon.vue";
import DashboardThermometerIcon from "@/plugins/new-ag-icons-2021/DashboardThermometerIcon.vue";
import DashboardTrafficConeIcon from "@/plugins/new-ag-icons-2021/DashoardTrafficConeIcon.vue";
import DashboardLadesaeuleIcon from "@/plugins/new-ag-icons-2021/DashboardLadesaeuleIcon.vue";
import DashboardEmailIcon from "@/plugins/new-ag-icons-2021/DashboardEmailIcon.vue";
import DashboardNewIcon from "@/plugins/new-ag-icons-2021/DashboardNewIcon.vue";
import DashboardContractIcon from "@/plugins/new-ag-icons-2021/DashboardContractIcon.vue";
import DashboardPressIcon from "@/plugins/new-ag-icons-2021/DashboardPressIcon.vue";
import DashboardFaqIcon from "@/plugins/new-ag-icons-2021/DashboardFaqIcon.vue";
import DashboardErlebenIcon from "@/plugins/new-ag-icons-2021/DashboardErlebenIcon.vue";
import MailIcon from "@/plugins/new-ag-icons-2021/MailIcon.vue";
import CallIcon from "@/plugins/new-ag-icons-2021/CallIcon.vue";
import ThumbsUpIcon from "@/plugins/new-ag-icons-2021/ThumbsUpIcon.vue";
import CheckmarkIcon from "@/plugins/new-ag-icons-2021/CheckmarkIcon.vue";
import FaqIcon from "@/plugins/new-ag-icons-2021/FaqIcon.vue";
import CommuneIcon from "@/plugins/new-ag-icons-2021/CommuneIcon.vue";
import WaermeIcon from "@/plugins/new-ag-icons-2021/WaermeIcon.vue";
import ArrowRightIcon from "@/plugins/new-ag-icons-2021/ArrowRightIcon.vue";
import NewsWhiteIcon from "@/plugins/new-ag-icons-2021/NewsWhiteIcon.vue";
import NachhaltigkeitIcon from "@/plugins/new-ag-icons-2021/NachhaltigkeitIcon.vue";
import NachhaltigkeitMenuIcon from "@/plugins/new-ag-icons-2021/NachhaltigkeitMenuIcon.vue";
import NotificationsIcon from "@/plugins/new-ag-icons-2021/NotificationsIcon.vue";
import ThermometerIcon from "@/plugins/new-ag-icons-2021/ThermometerIcon.vue";
import DownloadIcon from "@/plugins/new-ag-icons-2021/DownloadIcon.vue";
import DocumentJahresrechnung from "@/plugins/new-ag-icons-2021/DocumentJahresrechnung.vue";
import DocumentSchlussrechnung from "@/plugins/new-ag-icons-2021/DocumentSchlussrechnung.vue";
import DocumentTestatGas from "@/plugins/new-ag-icons-2021/DocumentTestatGas.vue";
import DocumentTestatStrom from "@/plugins/new-ag-icons-2021/DocumentTestatStrom.vue";
import DocumentVorauszahlung from "@/plugins/new-ag-icons-2021/DocumentVorauszahlung.vue";
import DocumentDefault from "@/plugins/new-ag-icons-2021/DocumentDefault.vue";
import DocumentTestatWasser from "@/plugins/new-ag-icons-2021/DocumentTestatWasser.vue";
import VeranstaltungIcon from "@/plugins/new-ag-icons-2021/VeranstaltungIcon.vue";
import Unterrichtsmaterial from "@/plugins/new-ag-icons-2021/Unterrichtsmaterial.vue";
import Exkursion from "@/plugins/new-ag-icons-2021/Exkursion.vue";
import Meldungen from "@/plugins/new-ag-icons-2021/Meldungen.vue";
import Sponsoring from "@/plugins/new-ag-icons-2021/Sponsoring.vue";
import VeranstaltungenDashboard from "@/plugins/new-ag-icons-2021/VeranstaltungenDashboard.vue";
import UnterrichtsmaterialDashboard from "@/plugins/new-ag-icons-2021/UnterrichtsmaterialDashboard.vue";
import ExkursionDashboard from "@/plugins/new-ag-icons-2021/ExkursionDashboard.vue";
import SponsoringDashboard from "@/plugins/new-ag-icons-2021/SponsoringDashboard.vue";
import MeldungenDashboard from "@/plugins/new-ag-icons-2021/MeldungenDashboard.vue";
import KontaktIcon from "@/plugins/new-ag-icons-2021/KontaktIcon.vue";
import KontaktDashboard from "@/plugins/new-ag-icons-2021/KontaktDashboard.vue";
import BildungsportalDashboard from "@/plugins/new-ag-icons-2021/BildungsportalDashboard.vue";
import Bildungsportal from "@/plugins/new-ag-icons-2021/Bildungsportal.vue";
import MagazinDashboard from "@/plugins/new-ag-icons-2021/MagazinDashboard.vue";
import AboutDashboard from "@/plugins/new-ag-icons-2021/AboutDashboard.vue";
import KommunalportalDashboard from "@/plugins/new-ag-icons-2021/kommunalportalDashboard.vue";
import Kommunalportal from "@/plugins/new-ag-icons-2021/kommunalportal.vue";
import Mail2Icon from "@/plugins/new-ag-icons-2021/Mail2Icon.vue";
import NetzwerkIcon from "@/plugins/new-ag-icons-2021/NetzwerkIcon.vue";
import Light from "@/plugins/new-ag-icons-2021/Light.vue";
import ReadIcon from "@/plugins/new-ag-icons-2021/ReadIcon.vue";
import UnreadIcon from "@/plugins/new-ag-icons-2021/UnreadIcon.vue";
import MenuLogoutIcon from "@/plugins/new-ag-icons-2021/MenuLogoutIcon.vue";
import MenuImprintIcon from "@/plugins/new-ag-icons-2021/MenuImprintIcon.vue";
import MenuAccountIcon from "@/plugins/new-ag-icons-2021/MenuAccountIcon.vue";
import MenuNewsIcon from "@/plugins/new-ag-icons-2021/MenuNewsIcon.vue";
import MenuBildungsportalIcon from "@/plugins/new-ag-icons-2021/MenuBildungsportalIcon.vue";
import MenuSponsoringIcon from "@/plugins/new-ag-icons-2021/MenuSponsoringIcon.vue";
import MenuEventsIcon from "@/plugins/new-ag-icons-2021/MenuEventsIcon.vue";
import MenuNachhaltigkeitIcon from "@/plugins/new-ag-icons-2021/MenuNachhaltigkeitIcon.vue";
import MenuVersorgungIcon from "@/plugins/new-ag-icons-2021/MenuVersorgungIcon.vue";
import MenuDocumentsIcon from "@/plugins/new-ag-icons-2021/MenuDocumentsIcon.vue";
import MenuDashboardIcon from "@/plugins/new-ag-icons-2021/MenuDashboardIcon.vue";
import MobileMappingIcon from "@/plugins/new-ag-icons-2021/MobileMappingIcon.vue";
import MaintenanceIcon from "@/plugins/new-ag-icons-2021/MaintenanceIcon.vue";
import KommunalportalMenu from "@/plugins/new-ag-icons-2021/KommunalportalMenu.vue";

export default {
  strom: {
    component: StromIcon
  },
  gas: {
    component: GasIcon
  },
  trinkwasser: {
    component: TrinkwasserIcon
  },
  abwasser: {
    component: AbwasserIcon
  },
  entsorgung: {
    component: EntsorgungIcon
  },
  strassenbeleuchtung: {
    component: StrassenbeleuchtungIcon
  },
  mobilitaet: {
    component: MobilitaetIcon
  },
  oepnv: {
    component: OepnvIcon
  },
  erneuerbareEnergien: {
    component: ErneuerbareEnergienIcon
  },
  energienaheDienstleistungen: {
    component: EnergienaheDienstleistungenIcon
  },
  baeder: {
    component: BaederIcon
  },
  engagement: {
    component: EngagementIcon
  },
  quartiersentwicklung: {
    component: QuartiersentwicklungIcon
  },
  klimaUmweltschutz: {
    component: KlimaUmweltschutzIcon
  },
  kontakte: {
    component: KontakteIcon
  },
  ueberNew: {
    component: UeberNewIcon
  },
  news: {
    component: NewsIcon
  },
  stoermeldungen: {
    component: StoermeldungenIcon
  },
  bauprojekte: {
    component: BauprojekteIcon
  },
  foerdermoeglichkeiten: {
    component: FoerdermoeglichkeitenIcon
  },
  wissen: {
    component: WissenIcon
  },
  user: {
    component: UserIcon
  },
  kommunalrabatt: {
    component: KommunalrabattIcon
  },
  magazin: {
    component: MagazinIcon
  },
  magazinDashboard: {
    component: MagazinDashboard
  },
  dashboardRabattprozess: {
    component: DashboardRabattprozessIcon
  },
  dashboardHandshake: {
    component: DashboardHandshakeIcon
  },
  dashboardThermometer: {
    component: DashboardThermometerIcon
  },
  dashboardTrafficCone: {
    component: DashboardTrafficConeIcon
  },
  dashboardLadesaeule: {
    component: DashboardLadesaeuleIcon
  },
  dashboardEmail: {
    component: DashboardEmailIcon
  },
  dashboardNew: {
    component: DashboardNewIcon
  },
  dashboardContract: {
    component: DashboardContractIcon
  },
  dashboardPress: {
    component: DashboardPressIcon
  },
  dashboardErleben: {
    component: DashboardErlebenIcon
  },
  dashboardFaq: {
    component: DashboardFaqIcon
  },
  mailIcon: {
    component: MailIcon
  },
  callIcon: {
    component: CallIcon
  },
  thumbsUp: {
    component: ThumbsUpIcon
  },
  checkmark: {
    component: CheckmarkIcon
  },
  faq: {
    component: FaqIcon
  },
  commune: {
    component: CommuneIcon
  },
  waerme: {
    component: WaermeIcon
  },
  arrowRight: {
    component: ArrowRightIcon
  },
  newsWhite: {
    component: NewsWhiteIcon
  },
  nachhaltigkeit: {
    component: NachhaltigkeitIcon
  },
  nachhaltigkeitMenu: {
    component: NachhaltigkeitMenuIcon
  },
  notifications: {
    component: NotificationsIcon
  },
  thermometer: {
    component: ThermometerIcon
  },
  download: {
    component: DownloadIcon
  },
  documentJahresrechnung: {
    component: DocumentJahresrechnung
  },
  documentSchlussrechnung: {
    component: DocumentSchlussrechnung
  },
  documentTestatGas: {
    component: DocumentTestatGas
  },
  documentTestatStrom: {
    component: DocumentTestatStrom
  },
  documentTestatWasser: {
    component: DocumentTestatWasser
  },
  documentVorauszahlung: {
    component: DocumentVorauszahlung
  },
  documentDefault: {
    component: DocumentDefault
  },
  veranstaltung: {
    component: VeranstaltungIcon
  },
  veranstaltungDashboard: {
    component: VeranstaltungenDashboard
  },
  unterrichtsmaterial: {
    component: Unterrichtsmaterial
  },
  unterrichtsmaterialDashboard: {
    component: UnterrichtsmaterialDashboard
  },
  exkursion: {
    component: Exkursion
  },
  exkursionDashboard: {
    component: ExkursionDashboard
  },
  meldungen: {
    component: Meldungen
  },
  meldungenDashboard: {
    component: MeldungenDashboard
  },
  sponsoring: {
    component: Sponsoring
  },
  sponsoringDashboard: {
    component: SponsoringDashboard
  },
  kontakt: {
    component: KontaktIcon
  },
  kontaktDashboard: {
    component: KontaktDashboard
  },
  bildungsportalDashboard: {
    component: BildungsportalDashboard
  },
  bildungsportal: {
    component: Bildungsportal
  },
  aboutDashboard: {
    component: AboutDashboard
  },
  kommunalportal: {
    component: Kommunalportal
  },
  kommunalportalDashboard: {
    component: KommunalportalDashboard
  },
    mail2: {
      component: Mail2Icon
    },
    netzwerk: {
      component: NetzwerkIcon
    },
    lightbulb: {
      component: Light
    },
    read: {
      component: ReadIcon
    },
    unread: {
        component: UnreadIcon
    },
    menuLogout: {
      component: MenuLogoutIcon
    },
    menuImprint: {
      component: MenuImprintIcon
    },
    menuAccount: {
      component: MenuAccountIcon
    },
    menuNews: {
      component: MenuNewsIcon
    },
    menuBildungsportal: {
      component: MenuBildungsportalIcon
    },
    menuSponsoring: {
      component: MenuSponsoringIcon
    },
    menuEvents: {
      component: MenuEventsIcon
    },
    menuNachhaltigkeit: {
      component: MenuNachhaltigkeitIcon
    },
    menuVersorgung: {
      component: MenuVersorgungIcon
    },
    menuDocuments: {
      component: MenuDocumentsIcon
    },
    menuDashboard: {
      component: MenuDashboardIcon
    },
  mobileMapping: {
    component: MobileMappingIcon
  },
  maintenance: {
    component: MaintenanceIcon
  },
  menuKommunalportal: {
    component: KommunalportalMenu
  }
};
